import type { LoggerConfiguration, datadogLogs, Logger } from '@datadog/browser-logs';

declare global {
  interface Window {
    datadogLogs: typeof datadogLogs;
  }
}

export const enum DatadogTeam {
  BuyerXP = 'BuyerXP',
  Heatmaps = 'heatmaps',
}

export function createDatadogLogger(
  loggerName: string,
  teamName: DatadogTeam,
  config?: LoggerConfiguration,
): Logger | undefined {
  if (!loggerName) {
    throw new Error('Datadog loggerName is not defined');
  }

  if (!teamName) {
    throw new Error('Datadog logger teamName is not defined');
  }

  const logger = window?.datadogLogs?.createLogger(loggerName, config || {});
  logger?.addContext('team', teamName);

  return logger;
}
